import { useSelector } from "react-redux";
import reduxModule from "./redux";

export const useFile = () => {
  const state = useSelector((state) => state.useFile);

  return {
    uploadAdBanner: (file, callback = null) =>
      reduxModule.uploadAdBanner(file, callback),

    state: state,

    // excelResponse: state?.Excel,

    file: state?.file,
  };
};
